(() => {
  const init = async (root) => {
    const wrap = root.querySelector('[data-leo-map]');
    if (!wrap || wrap.dataset.ready) return;
    wrap.dataset.ready = '1';
    const svg = wrap.querySelector('[data-leo-map-svg]');
    const tip = wrap.querySelector('[data-leo-map-tip]');
    let data;
    try { data = await (await fetch(wrap.dataset.src)).json(); } catch (e) { return; }
    const { cols, rows } = data.grid;
    svg.setAttribute('viewBox', `0 0 ${cols} ${rows}`);
    const r = 0.27;
    const dot = (x, y) => `M${(x + 0.5 - r).toFixed(2)} ${(y + 0.5).toFixed(2)}a${r} ${r} 0 1 0 ${2 * r} 0a${r} ${r} 0 1 0 ${-2 * r} 0z`;
    const byCc = {};
    const cell = {};
    let other = '';
    data.dots.forEach((d) => {
      cell[d.x + ':' + d.y] = d.cc;
      if (data.clients[d.cc]) byCc[d.cc] = (byCc[d.cc] || '') + dot(d.x, d.y);
      else other += dot(d.x, d.y);
    });
    const ns = 'http://www.w3.org/2000/svg';
    const o = document.createElementNS(ns, 'path'); o.setAttribute('d', other); o.setAttribute('class', 'o'); svg.appendChild(o);
    const paths = {};
    Object.keys(byCc).forEach((cc) => {
      const p = document.createElementNS(ns, 'path');
      p.setAttribute('d', byCc[cc]); p.setAttribute('class', 'c'); p.dataset.cc = cc;
      svg.appendChild(p); paths[cc] = p;
    });
    const io = new IntersectionObserver((en) => {
      if (!en[0].isIntersecting) return;
      Object.values(paths).forEach((p) => {
        const box = p.getBBox(); p.style.animationDelay = (box.x / cols * 0.6).toFixed(2) + 's'; p.classList.add('is-in');
      });
      io.disconnect();
    }, { threshold: 0.2 });
    io.observe(svg);
    let hot = null;
    const show = (cc, ex, ey) => {
      if (hot && hot !== cc) paths[hot].classList.remove('is-hot');
      if (!cc) { hot = null; tip.hidden = true; return; }
      hot = cc; paths[cc].classList.add('is-hot');
      const c = data.clients[cc];
      const flag = tip.querySelector('[data-tip-flag]'); flag.src = 'https://flagcdn.com/w80/' + cc.toLowerCase() + '.png'; flag.alt = c.name + ' flag';
      tip.querySelector('[data-tip-name]').textContent = `${c.name} · ${c.clients.toLocaleString('en-US')} client${c.clients === 1 ? '' : 's'}`;
      tip.querySelector('[data-tip-meta]').textContent = `#${c.rank} MARKET`;
      const b = wrap.getBoundingClientRect();
      let left = ex - b.left; const top = ey - b.top;
      tip.hidden = false;
      const w = tip.offsetWidth;
      tip.style.left = Math.min(left, b.width - w - 16) + 'px';
      tip.style.top = top + 'px';
    };
    const locate = (e) => {
      const pt = svg.createSVGPoint(); pt.x = e.clientX; pt.y = e.clientY;
      const p = pt.matrixTransform(svg.getScreenCTM().inverse());
      const fx = Math.floor(p.x); const fy = Math.floor(p.y);
      let cc = cell[fx + ':' + fy];
      if (!cc || !paths[cc]) {
        let best = 9;
        for (let dx = -1; dx <= 1; dx++) for (let dy = -1; dy <= 1; dy++) {
          const k = cell[(fx + dx) + ':' + (fy + dy)];
          if (!k || !paths[k]) continue;
          const d = Math.hypot(fx + dx + 0.5 - p.x, fy + dy + 0.5 - p.y);
          if (d < best) { best = d; cc = k; }
        }
      }
      show(cc && paths[cc] ? cc : null, e.clientX, e.clientY);
    };
    svg.addEventListener('pointermove', (e) => { if (e.pointerType === 'mouse') locate(e); });
    svg.addEventListener('pointerleave', (e) => { if (e.pointerType === 'mouse') show(null); });
    const pins = [...wrap.querySelectorAll('.leo-proof__pin')].filter((p) => p.querySelector('.leo-proof__chip'));
    const closePins = () => pins.forEach((p) => p.classList.remove('is-open'));
    const mobile = window.matchMedia('(max-width: 989px)');
    const openPin = (pin) => {
      closePins(); show(null);
      pin.classList.add('is-open');
      const chip = pin.querySelector('.leo-proof__chip');
      pin.style.setProperty('--shift', '0px');
      const b = wrap.getBoundingClientRect(); const r = chip.getBoundingClientRect();
      let shift = 0;
      if (r.left < b.left + 8) shift = b.left + 8 - r.left;
      if (r.right > b.right - 8) shift = b.right - 8 - r.right;
      pin.style.setProperty('--shift', shift + 'px');
    };
    const nearPin = (x, y) => {
      let best = null; let dist = 7;
      pins.forEach((p) => { const r = p.getBoundingClientRect(); const d = Math.hypot(r.left - x, r.top - y); if (d < dist) { dist = d; best = p; } });
      return best;
    };
    svg.addEventListener('click', (e) => {
      e.stopPropagation();
      const pin = mobile.matches ? nearPin(e.clientX, e.clientY) : null;
      if (pin && !pin.classList.contains('is-open')) { openPin(pin); return; }
      closePins(); locate(e);
    });
    document.addEventListener('click', (e) => { if (!wrap.contains(e.target)) { show(null); closePins(); } });
  };
  const bars = (root) => root.querySelectorAll('[data-leo-bar]').forEach((bar) => {
    if (bar.dataset.ready) return; bar.dataset.ready = '1';
    const play = () => { bar.classList.remove('is-play'); void bar.offsetWidth; bar.classList.add('is-play'); };
    new IntersectionObserver((en) => en.forEach((e) => { if (e.isIntersecting) play(); else bar.classList.remove('is-play'); }), { threshold: 0.45 }).observe(bar);
    bar.addEventListener('click', play);
  });
  bars(document);
  document.addEventListener('shopify:section:load', (e) => bars(e.target));
  init(document);
  document.addEventListener('shopify:section:load', (e) => init(e.target));
})();